import { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';
import { cx } from './cx';
import { Icon } from './Icon';
import { Link } from './Link';

export interface BackLinkProps {
  /** Destination href (e.g. the list route). */
  href?: string;
  /** Click handler — for client-side navigation (router). */
  onClick?: () => void;
  className?: string;
  children: ReactNode;
}

/**
 * Back navigation link — a left arrow + label ("Back to approvals"). The shared
 * way to return to a parent list from a detail page. Composes the Link + Icon
 * primitives (quiet variant).
 */
export const BackLink = ({
  href = '#',
  onClick,
  className,
  children,
}: BackLinkProps) => (
  <Link
    href={href}
    onClick={
      onClick
        ? e => {
            e.preventDefault();
            onClick();
          }
        : undefined
    }
    variant="quiet"
    className={cx('gap-1.5', className)}
  >
    <Icon as={ArrowLeft} size="sm" />
    {children}
  </Link>
);
